module.exports = __webpack_public_path__ + "static/br-1-bc1a45fb31bcda65c430a1793828006d.png";